module.exports = __webpack_public_path__ + "img/3.11e0c375.jpg";